<div class="crawl-management">
  <div class="header">
    <h1>🕷️ Crawl Management</h1>
    <p>Manage domain crawls and monitor crawl progress</p>
  </div>

  <div class="actions">
    <button 
      (click)="loadDomains()" 
      [disabled]="loadingDomains"
      class="btn btn-primary">
      {{ loadingDomains ? 'Loading...' : 'Refresh Domains' }}
    </button>
  </div>

  <div *ngIf="error" class="error-message">
    <p>❌ {{ error }}</p>
  </div>

  <div *ngIf="loadingDomains && domains.length === 0" class="loading">
    <p>Loading domains...</p>
  </div>

  <div *ngIf="!loadingDomains && domains.length === 0" class="empty-state">
    <p>No domains found. Start a crawl from the Page Comparison page.</p>
  </div>

  <div *ngIf="domains.length > 0" class="domains-list">
    <div *ngFor="let domain of domains" class="domain-card">
      <div class="domain-header">
        <h2>{{ domain }}</h2>
        <span [class]="'status-badge ' + getStatusClass(domainStatuses.get(domain)?.status || null)">
          {{ getStatusText(domainStatuses.get(domain)?.status || null) }}
        </span>
      </div>

      <div *ngIf="domainStatuses.get(domain)?.error" class="error-message">
        <p>❌ {{ domainStatuses.get(domain)?.error }}</p>
      </div>

      <div *ngIf="domainStatuses.get(domain)?.status" class="status-details">
        <div class="progress-bar-container">
          <div class="progress-bar">
            <div 
              class="progress-fill" 
              [style.width.%]="getProgressPercentage(domainStatuses.get(domain)?.status || null)">
            </div>
          </div>
          <div class="progress-text">
            {{ getProgressPercentage(domainStatuses.get(domain)?.status || null) }}% - 
            {{ formatProgress(domainStatuses.get(domain)?.status || null) }}
          </div>
        </div>

        <div class="stats-grid">
          <div class="stat">
            <span class="stat-label">Total Pages:</span>
            <span class="stat-value">{{ domainStatuses.get(domain)?.status?.totalUrls || 0 }}</span>
          </div>
          <div class="stat">
            <span class="stat-label">Pages Crawled:</span>
            <span class="stat-value success">{{ domainStatuses.get(domain)?.status?.pagesCrawled || 0 }}</span>
          </div>
          <div class="stat" *ngIf="domainStatuses.get(domain)?.status?.phase === 'analyzing'">
            <span class="stat-label">Pages Analyzed:</span>
            <span class="stat-value success">{{ domainStatuses.get(domain)?.status?.pagesAnalyzed || 0 }}</span>
          </div>
          <div class="stat">
            <span class="stat-label">Pages Failed:</span>
            <span class="stat-value error">{{ domainStatuses.get(domain)?.status?.pagesFailed || 0 }}</span>
            <button
              *ngIf="(domainStatuses.get(domain)?.status?.pagesFailed || 0) > 0"
              class="failed-toggle-link"
              (click)="toggleFailedPages(domain)"
              [disabled]="failedPagesLoading.get(domain)"
            >
              {{ failedPagesLoading.get(domain) ? 'Loading...' : (failedPagesExpanded.get(domain) ? 'Hide details' : 'Show details') }}
            </button>
          </div>
          <div class="stat" *ngIf="domainStatuses.get(domain)?.status?.phase === 'crawling'">
            <span class="stat-label">In Queue:</span>
            <span class="stat-value">{{ domainStatuses.get(domain)?.status?.pagesInQueue || 0 }}</span>
          </div>
        </div>

        <div class="failed-pages-panel" *ngIf="failedPagesExpanded.get(domain) && failedPages.get(domain)">
          <h3 class="failed-pages-title">Failed Pages</h3>
          <div *ngIf="(failedPages.get(domain) || []).length === 0" class="failed-pages-empty">
            No failed page details available.
          </div>
          <div class="failed-pages-list" *ngIf="(failedPages.get(domain) || []).length > 0">
            <div class="failed-page-item" *ngFor="let page of failedPages.get(domain)">
              <div class="failed-page-url">{{ page.url }}</div>
              <div class="failed-page-error">{{ page.errorMessage }}</div>
              <div class="failed-page-meta" *ngIf="page.createdAt">
                Task created: {{ page.createdAt | date:'short' }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="!domainStatuses.get(domain)?.status && !domainStatuses.get(domain)?.loading" class="no-status">
        <p>No crawl data available</p>
      </div>

      <div *ngIf="domainStatuses.get(domain)?.loading" class="loading">
        <p>Loading status...</p>
      </div>

      <div class="actions">
        <button 
          (click)="startCrawl(domain)" 
          [disabled]="domainStatuses.get(domain)?.loading"
          class="btn btn-primary">
          {{ domainStatuses.get(domain)?.loading ? 'Starting...' : 'Start Crawl' }}
        </button>
        <button 
          (click)="loadCrawlStatus(domain)" 
          [disabled]="domainStatuses.get(domain)?.loading"
          class="btn btn-secondary">
          Refresh Status
        </button>
      </div>
    </div>
  </div>
</div>





